import { environmentConfigFactory } from './models/environment-config.factory';
import {
  EnvironmentConfigSettings,
  ReadOnlyEnvironmentConfig,
} from './models/environment-config.model';

const CONFIG: EnvironmentConfigSettings = {
  production: false,
  appTitle: 'Nessy - Understanding Dyslexia',
  authAuthority: 'https://nessy-id-dev.nessy.com',
  clientId: 'nessy.understandingdyslexia.client',
  understandingDyslexiaApiPath: 'https://ud-api-dev.nessy.com/',
  identityApiPath: 'https://nessy-id-dev.nessy.com/api/',
  appInsightsInstrumentationKey: '',
};

export const environment: ReadOnlyEnvironmentConfig =
  environmentConfigFactory(CONFIG);
